<template>

  <div class="content-wrap">

    <div class="register-wrap">
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
              <ElLabel name="이름" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="nmRef" v-model="state.userParams.user_nm"  @update:modelValue="getNameMask"/>
                </template>
              </ElLabel>
              
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
              <ElLabel name="사번" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="employeeId" v-model="state.userParams.employee_id" :readonly='true'/>
                </template>
              </ElLabel>


          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <ElLabel name="아이디" required>
                <template #end="{id}">
                  <div class="input-group">

                  <ElInput :id="id" ref="userIdRef" v-model="state.userParams.user_id"/>

                    <ElButton 
                      type="btn-s-tb"  
                      @buttonClick="getUserIdCheck(state.userParams.user_id)" 
                    >
                      중복확인
                    </ElButton>
                  </div>
                </template>
              </ElLabel>

            <div id="" v-if="state.idCheckCode == '00002'" class="form-text stage-pi">
              {{ state.idCheckMsg }}
            </div>
            <div id="" v-else-if="state.idCheckCode == '02'" class="form-text text-primary">
              {{ state.idCheckMsg }}
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">

            <ElLabel name="휴대폰번호" :required="true">
              <template #end="{id}">
                <ElInput :id="id" ref="mobileRef" 
                v-model="state.userParams.mobile"  
                @update:modelValue="getMobileMask"
                :maxlength="13"
                />
              </template>
            </ElLabel>

          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <ElLabel  name="비밀번호 변경">
              <template #end="{id}">
                <ElButton class="form-control" @buttonClick="openPwdChng">비밀번호 변경</ElButton>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <ElLabel name="이메일" :required="true">
              <template #end="{id}">
                <ElInput :id="id" ref="emailRef" v-model="state.userParams.email"/>
              </template>
            </ElLabel>


          </div>
        </div>
      </div>

      <div class="row">
        
        <div class="col-md-12">
          <div class="mb-3"  @click="openModal('address')">

            <ElLabel name="주소" :required="true">
              <template #end="{id}">
                <div class="input-group">
                  <ElInput :id="id" ref="addressRef" v-model="state.userParams.address"/>

                  <ElButton
                      type="btn-s-tb"
                  >
                      주소검색
                  </ElButton>
                  <Address ref="addressModalRef" @em_address="getAddr" />
                </div>
              </template>
            </ElLabel>

          </div>
        </div>
        
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">

            <ElLabel name="주소 상세" :required="true">
              <template #end="{id}">
                <ElInput :id="id" ref="addressDetailRef" v-model="state.userParams.address_dtl"/>
              </template>
            </ElLabel>


          </div>
        </div>
      </div>

      <div class="row band">
        <!-- <div class="col-md-3">
          <div class="mb-3">
            <label for="" class="form-label">caption 1</label>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <label for="" class="form-label">caption 2</label>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <label for="" class="form-label">caption 3</label>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <label for="" class="form-label">caption 4</label>
          </div>
        </div> -->
        <!-- todo : captionList 적용해야함-->
      </div>

    </div><!-- //register-wrap -->

    <div class="text-end py-3">
      <ElButton type="primary" @buttonClick="goBack()">이전</ElButton>
      <ElButton type="primary" @buttonClick="fnEdit()">수정</ElButton>
    </div>

  </div>
  <PwdChangeModal ref="pwdChangeModalRef"/>
</template>

<script setup>

import { ref, reactive, onBeforeMount } from 'vue'
import api from '@/utils/api';
import common from "@/js/common";
import { useRouter } from "vue-router";
import routerCmn from '@/js/vueRouterCmn';

import Address from "@/components/common/modal/AddressModal.vue";
import PwdChangeModal from '@/components/common/modal/PwdChangeModal.vue';

import { useUserStore } from '@/store/user'
const userStore = useUserStore()
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { userSelect, idCheck, userEdit } from '@/api/userInfo';

const address = ref();
const addressModalRef = ref();
const pwdChangeModalRef = ref()
const nmRef = ref();
const userIdRef = ref();
const mobileRef = ref();
const emailRef = ref();
const addressRef = ref();
const addressDetailRef = ref();

const router = useRouter();
onBeforeMount(async () => {
  let param = {
    user_id: userStore.user.userId
  }
  try {
    setIsLoading(true)
    const res = await userSelect(param)
    let detailCf = res.rtn
    state.userParams.user_seq = detailCf.user_seq
    state.userParams.user_nm = detailCf.user_nm
    state.userParams.employee_id = detailCf.employee_id
    state.userParams.user_id = detailCf.user_id
    state.userParams.dept_cd = detailCf.dept_cd
    state.userParams.mobile = detailCf.mobile
    state.userParams.email = detailCf.email
    state.userParams.address = detailCf.address
    state.userParams.address_dtl = detailCf.address_dtl
    state.userParams.auth_grp_id = detailCf.auth_grp_id
    state.userParams.enable_yn = detailCf.enable_yn
    state.userParams.retire_yn = detailCf.retire_yn
  } catch (err) {
    console.error('사용자 입력/수정 api 에러', err)
    alert('사용자 입력/수정에 실패했습니다.')
    routerCmn.routerPush('/cf/MCF_US_002')
  } finally {
    setIsLoading(false)
  }
})

const state = reactive({
  userParams: {
    user_seq: '',
    user_nm: '',
    employee_id: '',
    user_id: '',
    dept_cd: '',
    mobile: '',
    email: '',
    address: '',
    address_dtl: '',
    auth_grp_id : '',
    enable_yn : 'Y',
    retire_yn : '',
    attachFileVO : {
      file_seq : '',
      file_div_id : '',
      del_file_seq : ''
    }
  },
  pageType: 'insert',
  typeName: '',
  idCheckMsg: '',
  idCheckCode: ''

})

const getNameMask = (data) => {
  if (data != undefined && data != "") {
    if (state.userParams.user_nm) {
      state.userParams.user_nm = common.checkSpecChar(state.userParams.user_nm);
    }
  }
};

const getAddr = (addr) => {
  state.userParams.address = addr.address;
};

//모바일 형식  (010-0000-0000)
const getMobileMask = (mobile) => {
  state.userParams.mobile = common.phoneFormat(mobile);
};

//아이디 조회(아이디 중복확인)
const getUserIdCheck = async () => {

  let params = {
    user_id: state.userParams.user_id
  }

  if (params.user_id.length > 0) {
    try {
      setIsLoading(true)
      const res = await idCheck(params)
      if (res.rtn.code_id == '00002') {
          state.idCheckCode = res.rtn.code_id
          state.idCheckMsg = codeStore.getCodeMsg(state.idCheckCode);
        } else { //TODO
          state.idCheckCode = "02"
          state.idCheckMsg = '사용 가능한 아이디 입니다.';
        }
      return state.idCheckMsg;
    } catch (err) {
      console.log('/userInfo/userSelect ERROR!! => ' + err)
      alert('api 에러 발생!!')
    } finally {
      setIsLoading(false)
    }
  } else {
    alert('사용자 아이디를 입력해 주세요.')
  }
}


const fnEdit = async () => {
  let msg = codeStore.getCodeMsg("77777");
  if(!state.userParams.user_nm.trim()){
    alert(msg);
    nmRef.value.input.focus();
    return false;
  }
  if(!state.userParams.user_id.trim()){
    alert(msg);
    userIdRef.value.input.focus();
    return false;
  }
  if(!state.userParams.mobile.trim()){
    alert(msg);
    mobileRef.value.input.focus();
    return false;
  }

  if (state.userParams.mobile.length < 13 ) {  //휴대폰번호 자릿수 체크 
    alert('휴대전화 번호를 확인하세요')
    mobileRef.value.input.focus();
    return false;
  }

  if(!state.userParams.email.trim()){
    alert(msg);
    emailRef.value.input.focus();
    return false;
  }
  if(!state.userParams.address.trim()){
    alert(msg);
    addressRef.value.input.focus();
    return false;
  }
  if(!state.userParams.address_dtl.trim()){
    alert(msg);
    addressDetailRef.value.input.focus();
    return false;
  }
  fnEditFn();
};

const fnEditFn = async () =>{
  if (state.userParams.user_seq) {
      try {
        
        setIsLoading(true)
        const res = await userEdit(state.userParams)
        if(res.code === '0000'){
          alert('회원정보를 수정했습니다.')
        }else{
          alert('회원정보 수정에 실패했습니다.')
        }
      } catch (err) {
        console.log('사용자 입력/수정 api 에러', err)
        alert('사용자 입력/수정에 실패했습니다.')
        // router.push('/')
      } finally {
        setIsLoading(false)
      }
    }else{
      alert('회원정보를 불러오는데 실패했습니다.')
      router.push('/')
    }

}
const openModal = (modal) => {
  if (modal == "address") {
    addressModalRef.value.openModal();
  }
};

const goBack = () => {
  router.go(-1)
}

function openPwdChng(){
  pwdChangeModalRef.value.openModal()
}


</script>